import { createContext } from 'react';

import { ExpandedServerIdContextProps } from './ExpandedServerIdContext.types';

export const ExpandedServerIdContext = createContext<ExpandedServerIdContextProps | undefined>(undefined);
